const OrderTypes = {
    SET_ORDER_RESPONSE:'SET_ORDER_RESPONSE',
    RESET_ORDER:'RESET_ORDER'
};

export default OrderTypes;